import type { PolicyEntity } from '@/shared/entities/PolicyEntity'
import type { MetadataEntity } from './MetadataEntity'

/**
 * Represents an entity for an authorization base role.
 *
 * @remarks
 * This class is used to encapsulate the properties of an authorization base role,
 * including its ID, name, associated policies, and metadata.
 */
export class BaseRoleEntity {
  /**
   * The unique identifier of the authorization base role.
   */
  id?: number

  /**
   * The name of the authorization base role.
   * This can be null if not explicitly set.
   */
  name?: string | null

  /**
   * The list of policies associated with the authorization base role.
   * This can be null if no policies are assigned.
   */
  policies?: Array<PolicyEntity> | null

  /**
   * Additional metadata associated with the authorization base role.
   */
  metadata?: MetadataEntity
}
